import React, {useState, useEffect} from 'react';
import { Linking, ScrollView, TouchableOpacity, View } from 'react-native'

import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import Modal from '../../../../components/Modal';
import { Image } from 'expo-image';
import IcomoonIcon from '../../../../components/IcomoonIcon';
import { Illustration } from '../../../../components/Illustration';
import Header from '../../../../navigation/Header';
import { useQuery } from '@tanstack/react-query';
import useActiveResidentCommunity from '../../../../hooks/useActiveResidentCommunity';
import api from '../../../../utils/api';
import dayjs from 'dayjs';


export default function AnnouncementDetailScreen({ navigation, route }) {
  const { announcementId } = route.params
  const { community, communityId } = useActiveResidentCommunity()

  const { isLoading, error, data: announcement, refetch } = useQuery({
    queryKey: ['community.announcement', announcementId],
    queryFn: () => api.get(`/communities/${communityId}/announcements/${announcementId}`).then(response => response.data),
  })

  useEffect(() => {
    markAsRead()
  }, []);

  function markAsRead(){
    api.post(`/communities/${communityId}/announcements/${announcementId}/read`)
  }
  
  const dateStr = announcement ? dayjs(announcement.created_at).format('DD/MMM/YYYY') : ''

  return (
    <View style={tw`flex-1 bg-[#F3F2F3]`}>
      <Header showBackButton style={tw`bg-[#F3F2F3]`}>
        <View style={tw``}>
          <Text style={tw`text-lg text-secondary font-600`}>{announcement ? announcement.title : 'Cargando...'}</Text>
        </View>
      </Header>

      <ScrollView contentContainerStyle={tw`px-4 py-2`}>
        <View style={tw`bg-white rounded-2xl border border-gray-200 px-5 py-4`}>
          <Text style={tw`text-gray-400 text-right`}>{dateStr}</Text>
          <Text style={tw`text-gray-600`}>{announcement?.text}</Text>
        </View>

        {
          announcement?.files?.length > 0 &&
            announcement.files.map(file =>
              <TouchableOpacity
                key={file.uuid}
                style={tw`row justify-between bg-white rounded-lg mb-2 mt-2 border border-gray-200`}
                onPress={() => Linking.openURL(file.url)}
              >
                {
                  file.file_type == "pdf" ?
                    <View style={tw`row py-3 px-4`}>
                      <Illustration name="pdfIcon" width={48} height={48} style={tw`mr-4`} />

                      <Text style={tw`flex-1 text-gray-500`}>{file.name}</Text>

                      <IcomoonIcon name='chevron-right' color={tw.color('secondary')} style={tw`ml-2 -mt-1`} />
                    </View>
                    :
                    <Image source={file.url} style={tw`h-40 w-full`} />
                }
              </TouchableOpacity>
          )
        }
      </ScrollView>
    </View>
  );
}
